<template lang="pug">
.camada__accordion
    el-collapse(accordion)
        el-collapse-item
            template(slot='title')
                i.mdi.mdi-drag-vertical.collapse-icon(
                    style='margin-right: 5px'
                )
                span.titulo {{ gerarTitulo() }}

            .layers(
                v-if='layer.codigo !== undefined',
                v-for='item in layersFiltrados'
            )
                span(style='font-size: 15px; margin-right: 5px')
                    i.el-icon-collection-tag(
                        :style='{ color: item.colorIcon || "#cacaca", "background-color": item.colorIcon || "#cacaca", "border-radius": "3px" }'
                    )

                el-switch.opcao-camada(
                    v-model='item.ativo',
                    @change='onChangeCamada(item)',
                    v-bind:active-text='item.nome.replace(" Paraguai", "")'
                )

                p.componente-camadas__opacidade__biomas
                    span {{ $t('mensagens.menuMapa.camadas.opacidade') }}:
                    el-slider(
                        v-model='item.opacidade',
                        @input='alterarOpacidade(item)',
                        :disabled='!item.ativo'
                    )
</template>

<script>
export default {
    name: 'CamadasAccordion',
    props: {
        layer: {
            type: Object
        },
        alterarOpacidade: {
            type: Function,
            required: true
        },
        onChangeCamada: {
            type: Function,
            required: true
        },
        layersFiltrados: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            titulo: ''
        };
    },
    created() {},
    methods: {
        gerarTitulo() {
            const pais = this.layersFiltrados.find(subCamada => {
                return subCamada.codigo.startsWith('PY');
            });
            if (pais) {
                return 'Paraguai';
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.camada__accordion {
    .el-collapse-item__header {
        i.collapse-icon {
            height: 20px;
        }
    }
    .titulo {
        color: #303133;
    }
    .layers {
        margin-left: 25px;
    }
}
</style>
